import React, {Component} from 'react';
import { connect} from 'react-redux'
import {bindActionCreators, compose} from 'redux'
import CTable from '@/components/CTable'
import CButton from '@/components/CButton'
import CBaseComponent from '@/components/CBaseComponent'
import { setReload } from "@/redux/common/action";
import _ from 'lodash'
import { tableData, authManageRoleListNewData} from './data'
import './index.scss'
import {message, Modal} from 'antd'
import { provadminlist,resetpasssword,provadminedit } from "@/servers/goodsManageApi";
import {withRouter} from "react-router-dom";
import { Form, Input,Radio,Checkbox,Button } from 'antd';


@CBaseComponent
class GoodsManageList extends Component{
  constructor(props) {
    super(props);
    this.getListData = this.getListData.bind(this);
    this.editHandler = this.editHandler.bind(this);
    this.modalOk = this.modalOk.bind(this);
    this.modalCancel = this.modalCancel.bind(this);
    this.onChange = this.onChange.bind(this)
    this.enterHandler = this.enterHandler.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    // reload时重新加载数据
    // this.getListData();
  }


  state = {
    columns: tableData.tHead,
    dataSource: tableData.tBody,
    page: tableData.tPage,
    loading: true,
    modal: {
      title: '重置密码',
      visible: false,
    },
    modalPageNewRef: null,//modal中pageNew的this
    formData:authManageRoleListNewData,
    checkNick: false,
    psd:'',
    psd2:'',
    id:''
  };

  // 获取用户列表数据
  getListData(){
    this.setState({
      loading: true
    });
    provadminlist().then(res=>{
      let data =JSON.parse(JSON.stringify(res.records[0].datalist))
      let total = 1;
      this.setState({
        dataSource: data,
        page: {...this.state.page, total},
        loading: false
      });
    }).catch(err=>{
      console.log(err,'rttt')
    })
  }

  modalOk(){
    if (this.state.psd !== this.state.psd2) {
      message.error('两次输入的密码不一致,请重新输入');
      return false
    }
    const params = {
      newpassword:this.state.psd,
      id:this.state.id
    }
    resetpasssword(params).then(res=>{
      if (res.statecode === 0) {
        message.success('密码重置成功');
        this.setState({
          modal: {...this.state.modal, visible: false},
          id:'',
          psd:'',
          psdw:''
        });
        this.getListData()
      } else {
        message.error('密码重置失败');
      }

      }).catch(err=>{
        this.setState({
          modal: {...this.state.modal, visible: false}
        });
      })
  }

  enterHandler(e,data){
    let value = e.target.value;
    if (data === 'psd') {
      this.setState({
        psd:value
      })
    } else {
      this.setState({
        psd2:value
      })
    }
  }

  modalCancel(){
    this.setState({
      modal: {...this.state.modal, visible: false}
    })
  }

  onChange(e,data){
    data.typeid = e.target.value
    const params = [
      {
        id:data.id,
        typeid:data.typeid,
        name: data.name
      }
    ]
     provadminedit(params).then(res=>{
       if (res.statecode === 0) {
         message.success('编辑成功');
         this.getListData()
       } else {
         message.error('编辑失败');
       }
    }).catch(err=>{
      console.log(err,'rttt')
    })
  }

  // 编辑当前行
  editHandler(data){
    this.setState({
      modal: {...this.state.modal, visible: true},
      id:data.id
    });
  }

  computeds(data){
    return data.typeid
  }

  componentWillMount(){

  }

  componentDidMount(){
    this.getListData();
  }
  render(){
    return (
        <div className='user-manage-list'>
          <CTable ref='userManageList' checked={false} loading={this.state.loading} columns={this.state.columns} dataSource={this.state.dataSource} onTableChange={this.onTableChange}>
            <div
                slot='operate1'
                render={(text, record, index) => (
                    <div className='operate'>
                      <Radio.Group onChange={(e) => this.onChange(e,record)} value={this.computeds(record)}>
                        <Radio value='允许'>允许</Radio>
                        <Radio value='不允许'>不允许</Radio>
                      </Radio.Group>
                    </div>
                )} />
            <div
                slot='operate'
                render={(text, record, index) => (
                    <div className='operate'>
                      <CButton type='text' authId='goodsManageListEdit' onClick={() => this.editHandler(record)}>重置</CButton>
                    </div>
                )} />
          </CTable>
          <Modal
              title={this.state.modal.title}
              visible={this.state.modal.visible}
              onOk={this.modalOk}
              onCancel={this.modalCancel}
              closable={false}
          >
            <div>
              <Form
                  labelCol={{ span: 6 }}
                  wrapperCol={{ span: 16 }}
                  style={{ maxWidth: 600 }}
              >
                <Form.Item
                    label="请输入新密码"
                    rules={[{ required: true, message: '请输入新密码' }]}
                >
                  <Input value={this.state.psd}
                         onChange={(e) => this.enterHandler(e,'psd')}
                         onPressEnter={(e) => this.enterHandler(e,'psd')}/>
                </Form.Item>
                <Form.Item
                    label="再次输入新密码"
                    rules={[{ required: true, message: '再次输入新密码' }]}
                >
                  <Input value={this.state.psd2}
                         onChange={(e) => this.enterHandler(e,'psd2')}
                         onPressEnter={(e) => this.enterHandler(e,'psd2')}/>
                </Form.Item>
              </Form>
            </div>
          </Modal>
        </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    reload: state.reload,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    setReload: bindActionCreators(setReload, dispatch)
  }
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(GoodsManageList);
